<template>
  <div>
    <b-card
      no-body
      class="my-0"
      :class="{ 'card-transparent-background': type == 'register' }"
      ><b-card-header v-if="type == 'view'" class="card-header-profile-border">
        <b-row>
          <b-col> <h4>Order Numbeer</h4></b-col>
          <b-col class="text-right"
            ><h4 class="orderNumber">#{{ order_number }}</h4>
            <span :class="'orderStatusSpan ' + status + '_status'">{{
              status_str
            }}</span></b-col
          >
        </b-row>
      </b-card-header>

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Driver assigned"
                label-for="assigned_driver"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ assigned_driver }}
                </span>
              </b-form-group>
            </b-col>

            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder form-group-datetime-doorder"
                label="Skip QR code reason"
                label-for="fulfilment_date"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ cancel_reason }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Order status "
                label-for="order_status"
                label-class="form-label-doorder"
              >
                <p
                  class="error_validation_message_p"
                  v-if="invalid_order_status"
                >
                  Please select status
                </p>
                <v-select
                  :options="order_status_list"
                  v-model="order_status"
                  :name="order_status"
                  :placeholder="'Select status'"
                  :reduce="(item) => item.code"
                  :clearable="false"
                  required
                >
                </v-select>
              </b-form-group> </b-col
          ></b-row>
          <b-row
            ><b-col md="12">
              <b-form-group
                label="Comment"
                label-for="comment"
                :comment="comment"
                label-class="form-label-doorder"
              >
                <b-form-textarea
                  id="comment"
                  class="form-control-doorder"
                  v-model="_comment"
                  :comment="comment"
                  rows="4"
                  >{{ _comment }}</b-form-textarea
                >
              </b-form-group>
            </b-col></b-row
          >
          <b-row class="justify-content-center mt-2">
            <b-col lg="4" sm="6" class="px-md-1 text-center">
              <b-button
                variant="doorder-primary"
                class="btn-bumblebee btn-doorder mb-1 w-100"
                v-if="!is_loading"
                @click="clickSubmitChangeOrderStatus"
                >Submit</b-button
              >
              <b-button
                type="button"
                disabled
                variant="doorder-primary"
                class="btn btn-bumblebee btn-doorder mb-1 w-100"
                v-else
              >
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="light"
                ></b-spinner>
                Loading</b-button
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";

import { getOrderStatusListForVSelect_OrderView } from "@/utils/helper-functions-doorder.js";

export default {
  name: "PackageDetails",
  components: {},
  props: [
    "type",
    "order_id",
    "order_number",
    "status",
    "status_str",
    "assigned_driver",
    "cancel_reason",
    "comment",
  ],
  data() {
    return {
      order_status_list: [],
      invalid_order_status: false,
      order_status: null,
      is_loading: false,
    };
  },
  beforeMount() {
    if (this.status != "pending" && this.status != "ready") {
      this.order_status = this.status;
    }
    this.order_status_list = getOrderStatusListForVSelect_OrderView();
  },
  mounted() {},
  computed: {
    _comment: {
      get() {
        return this.comment;
      },
      set(value) {
        this.$emit("update:comment", value);
      },
    },
  },
  methods: {
    getOrderStatusListForVSelect_OrderView,
    clickSubmitChangeOrderStatus() {
      console.log(
        "in click submit change status",
        this.order_id,
        this.order_status,
        this._comment,
        this.comment
      );

      let formData = new FormData();
      formData.append("client", "DOORDER");
      formData.append("status", this.order_status);
      if (this._comment != null) {
        formData.append("note", this._comment);
      }

      this.is_loading = true;
      axios
        .post("jobs/job-action/" + this.order_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Order is updated successfully ",
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;

            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/orders/order_details_components/DeliveryDetails.vue